/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Current status of the detection
 * @export
 */
export const ControlStatus3 = {
    New: 'NEW',
    Processing: 'PROCESSING',
    Escalated: 'ESCALATED',
    Hunting: 'HUNTING',
    Monitoring: 'MONITORING',
    Chatops: 'CHATOPS',
    Closed: 'CLOSED'
} as const;
export type ControlStatus3 = typeof ControlStatus3[keyof typeof ControlStatus3];


export function ControlStatus3FromJSON(json: any): ControlStatus3 {
    return ControlStatus3FromJSONTyped(json, false);
}

export function ControlStatus3FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlStatus3 {
    return json as ControlStatus3;
}

export function ControlStatus3ToJSON(value?: ControlStatus3 | null): any {
    return value as any;
}

